import { Schema } from '@bingads-webui-react/overreact';

import { edm } from './edm';

const schemaToModelMapping = {
  customer: 'Model/Customer',
  account: 'Model/Account',
  app: 'Model/App',
  campaign: 'Model/Campaign',
  ad_group: 'Model/AdGroup',
  keyword: 'Model/Keyword',
  ad: 'Model/Ad',
  negative_keyword_list: 'Model/NegativeKeywordList',
  negative_keyword: 'Model/NegativeKeyword',
  bulk_edit_session: 'Model/BulkEditSession',
  bulk_edit_result: 'Model/BulkEditResult',
  audience: 'Model/Audience',
  remessaging_audience: 'Model/RemessagingAudience',
  tag: 'Model/Tag',
  task_item: 'Model/TaskItem',
  goal: 'Model/Goal',
  conversion_advice: 'Model/ConversionAdvice',
  task_item_execution: 'Model/TaskItemExecution',
  ad_group_criterion: 'Model/AdGroupCriterion',
  audience_ad_group_criterion: 'Model/AudienceAdGroupCriterion',
  ad_group_audience_association: 'Model/AdGroupAudienceAssociation',
  audience_association: 'Model/AudienceAssociation',
  audience_criterion_with_b_i: 'Model/AudienceCriterionWithBI',
  ad_group_audience_criterion_with_b_i: 'Model/AdGroupAudienceCriterionWithBI',
  ad_group_audience_criterion: 'Model/AdGroupAudienceCriterion',
  campaign_criterion: 'Model/CampaignCriterion',
  campaign_audience_criterion: 'Model/CampaignAudienceCriterion',
  product_offer: 'Model/ProductOffer',
  product_partition: 'Model/ProductPartition',
  preference: 'Model/Preference',
  product_offer_store: 'Model/ProductOfferStore',
  image: 'Model/Image',
  ad_extension: 'Model/AdExtension',
  image_ad_extension: 'Model/ImageAdExtension',
  location_ad_extension: 'Model/LocationAdExtension',
  ad_extension_association: 'Model/AdExtensionAssociation',
  annotation_opt_out_info: 'Model/AnnotationOptOutInfo',
  automated_extension: 'Model/AutomatedExtension',
  label: 'Model/Label',
  budget: 'Model/Budget',
  portfolio_bid_strategy: 'Model/PortfolioBidStrategy',
  location: 'Model/Location',
  biddable_ad_group_criterion: 'Model/BiddableAdGroupCriterion',
  dsa_target: 'Model/DsaTarget',
  domain_category: 'Model/DomainCategory',
  negative_ad_group_criterion: 'Model/NegativeAdGroupCriterion',
  negative_ad_group_dsa_target: 'Model/NegativeAdGroupDsaTarget',
  negative_campaign_criterion: 'Model/NegativeCampaignCriterion',
  negative_campaign_dsa_target: 'Model/NegativeCampaignDsaTarget',
  dsa_search_term: 'Model/DsaSearchTerm',
  category: 'Model/Category',
  negative_keyword_conflict: 'Model/NegativeKeywordConflict',
  search_term: 'Model/SearchTerm',
  demographic: 'Model/Demographic',
  feed: 'Model/Feed',
  ad_customizer_attribute: 'Model/AdCustomizerAttribute',
  ad_customizer_attribute_value: 'Model/AdCustomizerAttributeValue',
  feed_item: 'Model/FeedItem',
  feed_upload_history: 'Model/FeedUploadHistory',
  feed_association: 'Model/FeedAssociation',
  recommendation: 'Model/Recommendation',
  performance_target: 'Model/PerformanceTarget',
  performance_target_instance: 'Model/PerformanceTargetInstance',
  experiment: 'Model/Experiment',
  performance_time_series: 'Model/PerformanceTimeSeries',
  language_detect: 'Model/LanguageDetect',
  responsive_search_ad_instance: 'Model/ResponsiveSearchAdInstance',
  smart_listing: 'Model/SmartListing',
  business: 'Model/Business',
  search_phrase: 'Model/SearchPhrase',
  product_group: 'Model/ProductGroup',
  product_attribute_statistic: 'Model/ProductAttributeStatistic',
  stock_image: 'Model/StockImage',
  placement_exclusion_list: 'Model/PlacementExclusionList',
  negative_site: 'Model/NegativeSite',
  asset_link: 'Model/AssetLink',
  asset_with_b_i_data: 'Model/AssetWithBIData',
  shared_entity_association: 'Model/SharedEntityAssociation',
  promotion_ad_extension: 'Model/PromotionAdExtension',
  note: 'Model/Note',
  note_segment: 'Model/NoteSegment',
  video: 'Model/Video',
  video_resource: 'Model/VideoResource',
  video_caption_file: 'Model/VideoCaptionFile',
  filter_link_ad_extension: 'Model/FilterLinkAdExtension',
  smart_page: 'Model/SmartPage',
  flyer_ad_extension: 'Model/FlyerAdExtension',
  reparenting_user_setting: 'Model/ReparentingUserSetting',
  video_ad_extension: 'Model/VideoAdExtension',
  account_label_association_count: 'Model/AccountLabelAssociationCount',
  location_targeting_info: 'Model/LocationTargetingInfo',
  responsive_search_ad: 'Model/ResponsiveSearchAd',
  import_recommendation: 'Model/ImportRecommendation',
  seasonality_adjustment: 'Model/SeasonalityAdjustment',
  r_s_a_ad_customizer_attribute: 'Model/RSAAdCustomizerAttribute',
  dimension_row: 'Model/DimensionRow',
  multi_account_overview: 'Model/MultiAccountOverview',
  report_data_report_info: 'Model/ReportDataReportInfo',
  upload_url: 'Model/UploadUrl',
  app_install_ad: 'Model/AppInstallAd',
  dynamic_search_ad: 'Model/DynamicSearchAd',
  expanded_text_ad: 'Model/ExpandedTextAd',
  mobile_ad: 'Model/MobileAd',
  product_ad: 'Model/ProductAd',
  responsive_ad: 'Model/ResponsiveAd',
  text_ad: 'Model/TextAd',
  ad_group_criterion_grid_data: 'Model/AdGroupCriterionGridData',
  order_item_bid_info: 'Model/OrderItemBidInfo',
  biddable_campaign_criterion: 'Model/BiddableCampaignCriterion',
  campaign_criterion_grid_data: 'Model/CampaignCriterionGridData',
  vertical_sub_account: 'Model/VerticalSubAccount',
  vertical_hotel_group: 'Model/VerticalHotelGroup',
  action_ad_extension: 'Model/ActionAdExtension',
  app_ad_extension: 'Model/AppAdExtension',
  call_ad_extension: 'Model/CallAdExtension',
  callout_ad_extension: 'Model/CalloutAdExtension',
  disclaimer_ad_extension: 'Model/DisclaimerAdExtension',
  dynamic_data_ad_extension: 'Model/DynamicDataAdExtension',
  price_ad_extension: 'Model/PriceAdExtension',
  review_ad_extension: 'Model/ReviewAdExtension',
  sitelink2_ad_extension: 'Model/Sitelink2AdExtension',
  structured_snippet_ad_extension: 'Model/StructuredSnippetAdExtension',
  application_install_goal: 'Model/ApplicationInstallGoal',
  destination_goal: 'Model/DestinationGoal',
  duration_goal: 'Model/DurationGoal',
  event_goal: 'Model/EventGoal',
  in_store_transaction_goal: 'Model/InStoreTransactionGoal',
  in_store_visit_goal: 'Model/InStoreVisitGoal',
  multi_stage_goal: 'Model/MultiStageGoal',
  offline_conversion_goal: 'Model/OfflineConversionGoal',
  page_views_per_visit_goal: 'Model/PageViewsPerVisitGoal',
  product_conversion_goal: 'Model/ProductConversionGoal',
  smart_goal: 'Model/SmartGoal',
  combined_list_audience: 'Model/CombinedListAudience',
  custom_audience: 'Model/CustomAudience',
  customer_list_audience: 'Model/CustomerListAudience',
  in_market_audience: 'Model/InMarketAudience',
  product_audience: 'Model/ProductAudience',
  remarketing_similar_audience: 'Model/RemarketingSimilarAudience',
  customer_shared_entity_association: 'Model/CustomerSharedEntityAssociation',
  bulk_download_task_item_execution: 'Model/BulkDownloadTaskItemExecution',
  bulk_upsert_task_item_execution: 'Model/BulkUpsertTaskItemExecution',
  offline_conversion_upload_task_item_execution: 'Model/OfflineConversionUploadTaskItemExecution',
  pps_reconciliation_report_manager_task_item_execution: 'Model/PpsReconciliationReportManagerTaskItemExecution',
  pps_reconciliation_report_upload_task_item_execution: 'Model/PpsReconciliationReportUploadTaskItemExecution',
  feed_upload_result: 'Model/FeedUploadResult',
  feed_import_result: 'Model/FeedImportResult',
  cloud_import_result: 'Model/CloudImportResult',
  cloud_import_v2_result: 'Model/CloudImportV2Result',
  google_tag_manager_import_result: 'Model/GoogleTagManagerImportResult',
  import_result: 'Model/ImportResult',
  multi_account_google_import_result: 'Model/MultiAccountGoogleImportResult',
  smart_import_scheduler_result: 'Model/SmartImportSchedulerResult',
  multi_account_download_result: 'Model/MultiAccountDownloadResult',
  bulk_upload_task_item_execution: 'Model/BulkUploadTaskItemExecution',
  report_data_task_item_execution: 'Model/ReportDataTaskItemExecution',
  script_task_item_execution: 'Model/ScriptTaskItemExecution',
  script_item_change: 'Model/ScriptItemChange',
  script_changes_summary: 'Model/ScriptChangesSummary',
  bing_places_task_item: 'Model/BingPlacesTaskItem',
  bulk_download_task_item: 'Model/BulkDownloadTaskItem',
  bulk_upsert_task_item: 'Model/BulkUpsertTaskItem',
  email_rule: 'Model/EmailRule',
  offline_conversion_upload_task_item: 'Model/OfflineConversionUploadTaskItem',
  pps_reconciliation_report_manager_task_item: 'Model/PpsReconciliationReportManagerTaskItem',
  pps_reconciliation_report_upload_task_item: 'Model/PpsReconciliationReportUploadTaskItem',
  facebook_task_item: 'Model/FacebookTaskItem',
  feed_upload_task_item_base: 'Model/FeedUploadTaskItemBase',
  create_feed_upload_task_item: 'Model/CreateFeedUploadTaskItem',
  import_feed_and_feed_mapping_upload_task_item: 'Model/ImportFeedAndFeedMappingUploadTaskItem',
  import_feed_item_upload_task_item: 'Model/ImportFeedItemUploadTaskItem',
  replace_feed_upload_task_item: 'Model/ReplaceFeedUploadTaskItem',
  r_s_a_ad_customizer_feed_upload_task_item: 'Model/RSAAdCustomizerFeedUploadTaskItem',
  update_feed_upload_task_item: 'Model/UpdateFeedUploadTaskItem',
  google_my_business_task_item: 'Model/GoogleMyBusinessTaskItem',
  amazon_import_task_item: 'Model/AmazonImportTaskItem',
  cloud_import_task_item: 'Model/CloudImportTaskItem',
  google_tag_manager_import_task_item: 'Model/GoogleTagManagerImportTaskItem',
  import_task_item: 'Model/ImportTaskItem',
  multi_account_google_import_task_item: 'Model/MultiAccountGoogleImportTaskItem',
  smart_import_scheduler_task_item: 'Model/SmartImportSchedulerTaskItem',
  multi_account_download_task_item: 'Model/MultiAccountDownloadTaskItem',
  multi_account_bulk_upload_task_item: 'Model/MultiAccountBulkUploadTaskItem',
  report_task_item: 'Model/ReportTaskItem',
  report_data_task_item: 'Model/ReportDataTaskItem',
  report_rule: 'Model/ReportRule',
  report_email_rule: 'Model/ReportEmailRule',
  script_task_item: 'Model/ScriptTaskItem',
  update_campaign_store_id_task_item: 'Model/UpdateCampaignStoreIdTaskItem',
  advertiser_rule: 'Model/AdvertiserRule',
  mca_schedule_post_task_item: 'Model/McaSchedulePostTaskItem',
  mca_social_metrics_sync_up_task_item: 'Model/McaSocialMetricsSyncUpTaskItem',
  mca_social_profile_init_task_item: 'Model/McaSocialProfileInitTaskItem',
  mca_report_job_task_item: 'Model/McaReportJobTaskItem',
  tip: 'Model/Tip',
  custom_column: 'Model/CustomColumn',
  company: 'Model/Company',
  industry: 'Model/Industry',
  job_function: 'Model/JobFunction',
  advice_event: 'Model/AdviceEvent',
  custom_event_for_event: 'Model/CustomEventForEvent',
  custom_event_for_value: 'Model/CustomEventForValue',
  page_load_event: 'Model/PageLoadEvent',
  travel_dimension_row: 'Model/TravelDimensionRow',
  report_data_column_info: 'Model/ReportDataColumnInfo',
  fb_event_owner: 'Model/FbEventOwner',
  fb_place: 'Model/FbPlace',
  http_request_message: 'Model/HttpRequestMessage',
  stock_image_asset: 'Model/StockImageAsset',
  report_data_enum_filter: 'Model/ReportDataEnumFilter',
  report_data_text_filter: 'Model/ReportDataTextFilter',
  report_data_column_set: 'Model/ReportDataColumnSet',
  ads_api_error: 'Model/AdsApiError',
  totals_with_performance_metrics: 'Model/TotalsWithPerformanceMetrics',
  account_totals: 'Model/AccountTotals',
  campaign_totals: 'Model/CampaignTotals',
  aggregate_budget: 'Model/AggregateBudget',
  performance_metrics: 'Model/PerformanceMetrics',
  custom_column_error_response: 'Model/CustomColumnErrorResponse',
  custom_column_error_detail_item: 'Model/CustomColumnErrorDetailItem',
  goal_performance_metrics: 'Model/GoalPerformanceMetrics',
  performance_metrics_totals_by_network_split: 'Model/PerformanceMetricsTotalsByNetworkSplit',
  custom_column_output_value: 'Model/CustomColumnOutputValue',
  insertion_order: 'Model/InsertionOrder',
  insertion_order_details: 'Model/InsertionOrderDetails',
  user: 'Model/User',
  product_condition: 'Model/ProductCondition',
  attribute_statistic: 'Model/AttributeStatistic',
  base_expression: 'Model/BaseExpression',
  filter: 'Model/Filter',
  entity_filter: 'Model/EntityFilter',
  child_entity_filter: 'Model/ChildEntityFilter',
  bulk_edit_action: 'Model/BulkEditAction',
  ad_group_audience_criterion_complex: 'Model/AdGroupAudienceCriterionComplex',
  ad_extension_association_complex: 'Model/AdExtensionAssociationComplex',
  dictionary_2_of_string__string: 'Model/Dictionary_2OfString_String',
  dictionary_2_of_string__import_statistics: 'Model/Dictionary_2OfString_ImportStatistics',
  target_totals: 'Model/TargetTotals',
  key_value_pair_2_of_int64__string: 'Model/KeyValuePair_2OfInt64_String',
  delivery_status_detail: 'Model/DeliveryStatusDetail',
  d_b_null: 'Model/DBNull',
  experiment_metrics: 'Model/ExperimentMetrics',
  dictionary_2_of_string__dictionary_2_of_string__int64: 'Model/Dictionary_2OfString_Dictionary_2OfString_Int64',
  asset: 'Model/Asset',
  manager_account: 'Model/ManagerAccount',
  entity_id_parent_id: 'Model/EntityIdParentId',
  owner: 'Model/Owner',
  rerun_run_report_result: 'Model/RerunRunReportResult',
  single_account_google_import_task_item: 'Model/SingleAccountGoogleImportTaskItem',
  single_account_import_result: 'Model/SingleAccountImportResult',
  image_asset: 'Model/ImageAsset',
  smart_estimation_point: 'Model/SmartEstimationPoint',
  budget_kpi_estimations_response: 'Model/BudgetKpiEstimationsResponse',
  ads_count: 'Model/AdsCount',
  ad_groups_count: 'Model/AdGroupsCount',
  dictionary_2_of_ad_type__int32: 'Model/Dictionary_2OfAdType_Int32',
  fb_business: 'Model/FbBusiness',
  fb_cover: 'Model/FbCover',
  fb_location: 'Model/FbLocation',
  fb_page: 'Model/FbPage',
  fb_picture: 'Model/FbPicture',
  fb_post: 'Model/FbPost',
  fb_rating: 'Model/FbRating',
  fb_photo: 'Model/FbPhoto',
  fb_call_to_action: 'Model/FbCallToAction',
  fb_event: 'Model/FbEvent',
  fb_event_time: 'Model/FbEventTime',
  fb_user: 'Model/FbUser',
  fb_id_name_map: 'Model/FbIdNameMap',
  smart_page_fb_error: 'Model/SmartPageFbError',
  smart_page_fb_errors: 'Model/SmartPageFbErrors',
  smart_page_metric: 'Model/SmartPageMetric',
  click_metric: 'Model/ClickMetric',
  smart_page_business_hours: 'Model/SmartPageBusinessHours',
  smart_page_time_slots: 'Model/SmartPageTimeSlots',
  smart_page_suggestion: 'Model/SmartPageSuggestion',
  smart_page_image: 'Model/SmartPageImage',
  multi_account_recommendation: 'Model/MultiAccountRecommendation',
  dictionary_2_of_verified_tracking_vendor_field__string: 'Model/Dictionary_2OfVerifiedTrackingVendorField_String',
  b_i_data_status: 'Model/BIDataStatus',
  http_response_message: 'Model/HttpResponseMessage',
  i_enumerable_1_of_attribute_statistic: 'Model/IEnumerable_1OfAttributeStatistic',
  grid_data_parameters: 'Model/GridDataParameters',
  conversion_goal_details: 'Model/ConversionGoalDetails',
  criterion: 'Model/Criterion',
  list_1_of_b_i_data_status: 'Model/List_1OfBIDataStatus',
  key_value_pair_2_of_string__string: 'Model/KeyValuePair_2OfString_String',
  blob: 'Model/Blob',
  i_enumerable_1_of_i_enumerable_1_of_string: 'Model/IEnumerable_1OfIEnumerable_1OfString',
  data_availability: 'Model/DataAvailability',
  report_parameters: 'Model/ReportParameters',
  report_preview_parameters: 'Model/ReportPreviewParameters',
  multi_account_overview_parameters: 'Model/MultiAccountOverviewParameters',
  multi_account_recommendation_parameters: 'Model/MultiAccountRecommendationParameters',
  key_value_pair_2_of_int32__boolean: 'Model/KeyValuePair_2OfInt32_Boolean',
  search_term_selection_item: 'Model/SearchTermSelectionItem',
  alert_information: 'Model/AlertInformation',
  fb_page_authorization_data: 'Model/FbPageAuthorizationData',
  i_enumerable_1_of_fb_page: 'Model/IEnumerable_1OfFbPage',
  ads_api_batch_errors: 'Model/AdsApiBatchErrors',
  smart_page_association: 'Model/SmartPageAssociation',
  smart_page_metric_set: 'Model/SmartPageMetricSet',
  smart_page_details: 'Model/SmartPageDetails',
  smart_page_partner_details: 'Model/SmartPagePartnerDetails',
  website_source_data: 'Model/WebsiteSourceData',
  entity_editorial_reasons_collection: 'Model/EntityEditorialReasonsCollection',
  ad_resource_not_eligible_reasons_collection: 'Model/AdResourceNotEligibleReasonsCollection',
  set_smart_listings_result: 'Model/SetSmartListingsResult',
  ad_strength_and_action_items: 'Model/AdStrengthAndActionItems',
  medias: 'Model/Medias',
  recommendation_media_option: 'Model/RecommendationMediaOption',
  recommendation_page_defination: 'Model/RecommendationPageDefination',
  media_generation_result: 'Model/MediaGenerationResult',
  image_generation: 'Model/ImageGeneration',
  media_output: 'Model/MediaOutput',
  budget_recommendation_response: 'Model/BudgetRecommendationResponse',
  target: 'Model/Target',
  mca_keyword: 'Model/McaKeyword',
  mca_ad: 'Model/McaAd',
  extracted_business_info: 'Model/ExtractedBusinessInfo',
  target_recommendation: 'Model/TargetRecommendation',
  a_b_testing_flight_log: 'Model/ABTestingFlightLog',
  a_b_testing_event_log: 'Model/ABTestingEventLog',
  date_range: 'Model/DateRange',
  tag_setting: 'Model/TagSetting',
  file_content_result: 'Model/FileContentResult',
  version: 'Model/Version',
  http_content: 'Model/HttpContent',
  key_value_pair_2_of_string__i_enumerable_1_of_string: 'Model/KeyValuePair_2OfString_IEnumerable_1OfString',
  stream_content: 'Model/StreamContent',
  read_only_memory_content: 'Model/ReadOnlyMemoryContent',
  multipart_content: 'Model/MultipartContent',
  multipart_form_data_content: 'Model/MultipartFormDataContent',
  byte_array_content: 'Model/ByteArrayContent',
  string_content: 'Model/StringContent',
  json_content: 'Model/JsonContent',
  header_encoding_selector_1_of_http_content: 'Model/HeaderEncodingSelector_1OfHttpContent',
  form_url_encoded_content: 'Model/FormUrlEncodedContent',
  http_method: 'Model/HttpMethod',
  uri: 'Model/Uri',
  account_inactive_reason: 'Model/AccountInactiveReason',
  quality_score_data: 'Model/QualityScoreData',
  segmented_performance_metrics: 'Model/SegmentedPerformanceMetrics',
  segmentation_key: 'Model/SegmentationKey',
  year_segmentation_key: 'Model/YearSegmentationKey',
  week_segmentation_key: 'Model/WeekSegmentationKey',
  top_vs_other_segmentation_key: 'Model/TopVsOtherSegmentationKey',
  quarter_segmentation_key: 'Model/QuarterSegmentationKey',
  network_segmentation_key: 'Model/NetworkSegmentationKey',
  month_segmentation_key: 'Model/MonthSegmentationKey',
  medium_segmentation_key: 'Model/MediumSegmentationKey',
  hour_of_the_day_segmentation_key: 'Model/HourOfTheDaySegmentationKey',
  goal_type_segmentation_key: 'Model/GoalTypeSegmentationKey',
  goal_name_segmentation_key: 'Model/GoalNameSegmentationKey',
  goal_category_segmentation_key: 'Model/GoalCategorySegmentationKey',
  device_type_segmentation_key: 'Model/DeviceTypeSegmentationKey',
  device_o_s_segmentation_key: 'Model/DeviceOSSegmentationKey',
  delivered_match_type_segmentation_key: 'Model/DeliveredMatchTypeSegmentationKey',
  day_segmentation_key: 'Model/DaySegmentationKey',
  day_of_the_week_segmentation_key: 'Model/DayOfTheWeekSegmentationKey',
  currency_segmentation_key: 'Model/CurrencySegmentationKey',
  bidded_match_type_segmentation_key: 'Model/BiddedMatchTypeSegmentationKey',
  audience_type_segmentation_key: 'Model/AudienceTypeSegmentationKey',
  audience_name_segmentation_key: 'Model/AudienceNameSegmentationKey',
  ad_scenario_segmentation_key: 'Model/AdScenarioSegmentationKey',
  ad_position_segmentation_key: 'Model/AdPositionSegmentationKey',
  phone_performance_metrics: 'Model/PhonePerformanceMetrics',
  segmented_phone_performance_metrics: 'Model/SegmentedPhonePerformanceMetrics',
  custom_parameter: 'Model/CustomParameter',
  bidding_scheme: 'Model/BiddingScheme',
  unknown_bidding_scheme: 'Model/UnknownBiddingScheme',
  target_roas_bidding_scheme: 'Model/TargetRoasBiddingScheme',
  target_impression_share_bidding_scheme: 'Model/TargetImpressionShareBiddingScheme',
  target_cpa_bidding_scheme: 'Model/TargetCpaBiddingScheme',
  percent_cpc_bidding_scheme: 'Model/PercentCpcBiddingScheme',
  max_roas_bidding_scheme: 'Model/MaxRoasBiddingScheme',
  max_conversion_value_bidding_scheme: 'Model/MaxConversionValueBiddingScheme',
  max_conversions_bidding_scheme: 'Model/MaxConversionsBiddingScheme',
  bid: 'Model/Bid',
  max_clicks_bidding_scheme: 'Model/MaxClicksBiddingScheme',
  manual_cpv_bidding_scheme: 'Model/ManualCpvBiddingScheme',
  manual_cpm_bidding_scheme: 'Model/ManualCpmBiddingScheme',
  manual_bidding_scheme: 'Model/ManualBiddingScheme',
  inherit_from_parent_bidding_scheme: 'Model/InheritFromParentBiddingScheme',
  enhanced_cpc_bidding_scheme: 'Model/EnhancedCpcBiddingScheme',
  cost_per_sale_bidding_scheme: 'Model/CostPerSaleBiddingScheme',
  commission_bidding_scheme: 'Model/CommissionBiddingScheme',
  campaign_settings: 'Model/CampaignSettings',
  smart_settings: 'Model/SmartSettings',
  verified_tracking_setting: 'Model/VerifiedTrackingSetting',
  verified_tracking_data: 'Model/VerifiedTrackingData',
  shopping_settings: 'Model/ShoppingSettings',
  expert_mode_settings: 'Model/ExpertModeSettings',
  dynamic_search_ads_setting: 'Model/DynamicSearchAdsSetting',
  disclaimer_setting: 'Model/DisclaimerSetting',
  audience_settings: 'Model/AudienceSettings',
  note_campaign_association: 'Model/NoteCampaignAssociation',
  note_ad_group_association: 'Model/NoteAdGroupAssociation',
  audience_criterion: 'Model/AudienceCriterion',
  bid_amount_detail: 'Model/BidAmountDetail',
  bid_estimation_data: 'Model/BidEstimationData',
  app_url: 'Model/AppUrl',
  label_association_counts: 'Model/LabelAssociationCounts',
  appeal: 'Model/Appeal',
  text_asset: 'Model/TextAsset',
  video_asset: 'Model/VideoAsset',
  ad_rotation: 'Model/AdRotation',
  updatable_date: 'Model/UpdatableDate',
  age_criterion: 'Model/AgeCriterion',
  day_time_criterion: 'Model/DayTimeCriterion',
  device_criterion: 'Model/DeviceCriterion',
  gender_criterion: 'Model/GenderCriterion',
  location_criterion: 'Model/LocationCriterion',
  geo_point: 'Model/GeoPoint',
  location_intent_criterion: 'Model/LocationIntentCriterion',
  profile_criterion: 'Model/ProfileCriterion',
  company_name_criterion: 'Model/CompanyNameCriterion',
  industry_criterion: 'Model/IndustryCriterion',
  job_function_criterion: 'Model/JobFunctionCriterion',
  radius_criterion: 'Model/RadiusCriterion',
  store_criterion: 'Model/StoreCriterion',
  webpage: 'Model/Webpage',
  webpage_parameter: 'Model/WebpageParameter',
  webpage_condition: 'Model/WebpageCondition',
  criterion_bid: 'Model/CriterionBid',
  fixed_bid: 'Model/FixedBid',
  bid_multiplier: 'Model/BidMultiplier',
  criterion_cashback: 'Model/CriterionCashback',
  cashback_adjustment: 'Model/CashbackAdjustment',
  bid_adjustment_recommendation: 'Model/BidAdjustmentRecommendation',
  schedule: 'Model/Schedule',
  day_time: 'Model/DayTime',
  key_value_pair_2_of_int64__campaign_editorial_reason_collection: 'Model/KeyValuePair_2OfInt64_CampaignEditorialReasonCollection',
  address: 'Model/Address',
  price_table_row: 'Model/PriceTableRow',
  setting: 'Model/Setting',
  target_setting: 'Model/TargetSetting',
  target_setting_detail: 'Model/TargetSettingDetail',
  co_op_setting: 'Model/CoOpSetting',
  recommendation_action: 'Model/RecommendationAction',
  metric_change: 'Model/MetricChange',
  product_group_cashback: 'Model/ProductGroupCashback',
  campaign_cashback: 'Model/CampaignCashback',
  ad_group_cashback: 'Model/AdGroupCashback',
  campaign_conversion_goal: 'Model/CampaignConversionGoal',
  account_item: 'Model/AccountItem',
  sharing_scope: 'Model/SharingScope',
  used_by: 'Model/UsedBy',
  goal_stage: 'Model/GoalStage',
  destination_goal_stage: 'Model/DestinationGoalStage',
  event_goal_stage: 'Model/EventGoalStage',
  selection: 'Model/Selection',
  comparison_date_range: 'Model/ComparisonDateRange',
  custom_column_definition: 'Model/CustomColumnDefinition',
  search_term_selection: 'Model/SearchTermSelection',
  performance_target_instance_selection: 'Model/PerformanceTargetInstanceSelection',
  dimension_report_selection: 'Model/DimensionReportSelection',
  automated_extension_selection: 'Model/AutomatedExtensionSelection',
  ad_extension_selection: 'Model/AdExtensionSelection',
  bulk_edit_batch_action: 'Model/BulkEditBatchAction',
  association_action: 'Model/AssociationAction',
  audience_association_action: 'Model/AudienceAssociationAction',
  label_association_action: 'Model/LabelAssociationAction',
  label_disassociation_action: 'Model/LabelDisassociationAction',
  bid_estimate_action: 'Model/BidEstimateAction',
  copy_action: 'Model/CopyAction',
  list_action: 'Model/ListAction',
  numeric_action: 'Model/NumericAction',
  query_only_action: 'Model/QueryOnlyAction',
  text_action: 'Model/TextAction',
  bulk_edit_item_change: 'Model/BulkEditItemChange',
  key_value_pair_2_of_string__list_1_of_editorial_error: 'Model/KeyValuePair_2OfString_List_1OfEditorialError',
  editorial_error: 'Model/EditorialError',
  api_editorial_error: 'Model/ApiEditorialError',
  mca_api_editorial_error: 'Model/McaApiEditorialError',
  editorial_info: 'Model/EditorialInfo',
  mca_editorial_reason: 'Model/McaEditorialReason',
  audience_expression: 'Model/AudienceExpression',
  page_visitors_who_visited_another_page_expression: 'Model/PageVisitorsWhoVisitedAnotherPageExpression',
  expression: 'Model/Expression',
  page_visitors_who_did_not_visit_another_page_expression: 'Model/PageVisitorsWhoDidNotVisitAnotherPageExpression',
  expression_collection: 'Model/ExpressionCollection',
  page_visitors_expression: 'Model/PageVisitorsExpression',
  custom_events_expression: 'Model/CustomEventsExpression',
  audience_set: 'Model/AudienceSet',
  dictionary_2_of_string__int64: 'Model/Dictionary_2OfString_Int64',
  annotation_opt_out: 'Model/AnnotationOptOut',
  aggregated_negative_keyword: 'Model/AggregatedNegativeKeyword',
  offline_conversion_file: 'Model/OfflineConversionFile',
  key_value_pair_2_of_int64__i_enumerable_1_of_ads_api_error: 'Model/KeyValuePair_2OfInt64_IEnumerable_1OfAdsApiError',
  cloud_import_task_base_result: 'Model/CloudImportTaskBaseResult',
  cloud_import_task_result: 'Model/CloudImportTaskResult',
  import_statistics: 'Model/ImportStatistics',
  entity_count: 'Model/EntityCount',
  key_value_pair_2_of_string__i_enumerable_1_of_ads_api_error: 'Model/KeyValuePair_2OfString_IEnumerable_1OfAdsApiError',
  key_value_pair_2_of_string__bulk_upload_entity_statistics: 'Model/KeyValuePair_2OfString_BulkUploadEntityStatistics',
  bulk_upload_entity_statistics: 'Model/BulkUploadEntityStatistics',
  bulk_file: 'Model/BulkFile',
  key_value_pair_2_of_string__ads_api_error: 'Model/KeyValuePair_2OfString_AdsApiError',
  bing_places_filter: 'Model/BingPlacesFilter',
  notification_delivery_option: 'Model/NotificationDeliveryOption',
  email_notification_delivery_option: 'Model/EmailNotificationDeliveryOption',
  import_user_preference: 'Model/ImportUserPreference',
  import_adjustment_for_numeric_property: 'Model/ImportAdjustmentForNumericProperty',
  import_prefix_and_suffix_for_string_property: 'Model/ImportPrefixAndSuffixForStringProperty',
  import_search_and_replace_for_string_property: 'Model/ImportSearchAndReplaceForStringProperty',
  facebook_import_context: 'Model/FacebookImportContext',
  google_my_business_filter: 'Model/GoogleMyBusinessFilter',
  amazon_import_context: 'Model/AmazonImportContext',
  ad_words_import_context: 'Model/AdWordsImportContext',
  import_user_preferences: 'Model/ImportUserPreferences',
  import_update_entity_preference: 'Model/ImportUpdateEntityPreference',
  import_append_dest_url_preference: 'Model/ImportAppendDestUrlPreference',
  import_search_and_replace_dest_url_preference: 'Model/ImportSearchAndReplaceDestUrlPreference',
  append_preferences_for_tracking_template: 'Model/AppendPreferencesForTrackingTemplate',
  search_and_replace_preferences_for_tracking_template: 'Model/SearchAndReplacePreferencesForTrackingTemplate',
  g_t_m_import_context: 'Model/GTMImportContext',
  g_t_m_tag_draft: 'Model/GTMTagDraft',
  google_account_property: 'Model/GoogleAccountProperty',
  file_import_context: 'Model/FileImportContext',
  smart_import_google_import_context: 'Model/SmartImportGoogleImportContext',
  smart_import_facebook_import_context: 'Model/SmartImportFacebookImportContext',
  aggregate_filter: 'Model/AggregateFilter',
  predicate: 'Model/Predicate',
  report_sort: 'Model/ReportSort',
  campaign_report_scope: 'Model/CampaignReportScope',
  ad_group_report_scope: 'Model/AdGroupReportScope',
  conditional_format: 'Model/ConditionalFormat',
  crop_settings: 'Model/CropSettings',
  seasonality_adjustment_campaign_association: 'Model/SeasonalityAdjustmentCampaignAssociation',
  migration_statuses: 'Model/MigrationStatuses',
  performance_target_metric: 'Model/PerformanceTargetMetric',
  feed_attribute: 'Model/FeedAttribute',
  feed_item_attribute_value: 'Model/FeedItemAttributeValue',
  feed_item_targets: 'Model/FeedItemTargets',
  feed_item_campaign_target: 'Model/FeedItemCampaignTarget',
  feed_item_adgroup_target: 'Model/FeedItemAdgroupTarget',
  feed_item_audience_target: 'Model/FeedItemAudienceTarget',
  feed_item_location_target: 'Model/FeedItemLocationTarget',
  feed_item_platform_target: 'Model/FeedItemPlatformTarget',
  feed_item_keyword_target: 'Model/FeedItemKeywordTarget',
  feed_upload_task_detail_base: 'Model/FeedUploadTaskDetailBase',
  update_feed_upload_task_detail: 'Model/UpdateFeedUploadTaskDetail',
  replace_feed_upload_task_detail: 'Model/ReplaceFeedUploadTaskDetail',
  create_feed_upload_task_detail: 'Model/CreateFeedUploadTaskDetail',
  feed_schedule_information: 'Model/FeedScheduleInformation',
  advice_summary: 'Model/AdviceSummary',
  advice_message: 'Model/AdviceMessage',
  goal_advice_summary: 'Model/GoalAdviceSummary',
  advice_item: 'Model/AdviceItem',
  event_advice_summary: 'Model/EventAdviceSummary',
  event_advice_detail: 'Model/EventAdviceDetail',
  last_import_info: 'Model/LastImportInfo',
  performance_data_point: 'Model/PerformanceDataPoint',
  performance_change_percent_metrics: 'Model/PerformanceChangePercentMetrics',
  segmented_performance_change_percent_metrics: 'Model/SegmentedPerformanceChangePercentMetrics',
  phone_performance_change_percent_metrics: 'Model/PhonePerformanceChangePercentMetrics',
  segmented_phone_performance_change_percent_metrics: 'Model/SegmentedPhonePerformanceChangePercentMetrics',
  smart_page_data_context: 'Model/SmartPageDataContext',
  smart_page_social_urls: 'Model/SmartPageSocialUrls',
  smart_page_video: 'Model/SmartPageVideo',
  smart_page_call_to_action: 'Model/SmartPageCallToAction',
  smart_page_location: 'Model/SmartPageLocation',
  uet_user_setting: 'Model/UetUserSetting',
  tag_info: 'Model/TagInfo',
  audience_item: 'Model/AudienceItem',
  goal_item: 'Model/GoalItem',
  tag_used_by_info: 'Model/TagUsedByInfo',
  used_by_pair: 'Model/UsedByPair',
  size: 'Model/Size',
  bid_below_first_page_detail: 'Model/BidBelowFirstPageDetail',
  negative_keyword_conflict_detail_collection: 'Model/NegativeKeywordConflictDetailCollection',
  negative_keyword_conflict_detail: 'Model/NegativeKeywordConflictDetail',
  experiment_statistic_1_of_int64: 'Model/ExperimentStatistic_1OfInt64',
  experiment_statistic_1_of_double: 'Model/ExperimentStatistic_1OfDouble',
  experiment_statistic_1_of_single: 'Model/ExperimentStatistic_1OfSingle',
  grid_data_filter: 'Model/GridDataFilter',
  ad_extension_association_grid_data_parameters: 'Model/AdExtensionAssociationGridDataParameters',
  automated_extension_grid_data_parameters: 'Model/AutomatedExtensionGridDataParameters',
  grid_pagination: 'Model/GridPagination',
  editorial_language_to_publisher_countries: 'Model/EditorialLanguageToPublisherCountries',
  editorial_reason: 'Model/EditorialReason',
  ad_resource_not_eligible_reason: 'Model/AdResourceNotEligibleReason',
  campaign_management_error_detail: 'Model/CampaignManagementErrorDetail',
  editorial_error_detail: 'Model/EditorialErrorDetail',
  publisher_country_editorial_errors: 'Model/PublisherCountryEditorialErrors',
  recommendation_image: 'Model/RecommendationImage',
  recommendation_image_option: 'Model/RecommendationImageOption',
  media_asset: 'Model/MediaAsset',
  image_filter: 'Model/ImageFilter',
  image_filter_parameter: 'Model/ImageFilterParameter',
  crop_setting: 'Model/CropSetting',
  output_image: 'Model/OutputImage',
  budget_info: 'Model/BudgetInfo',
  age_target: 'Model/AgeTarget',
  gender_target: 'Model/GenderTarget',
  geo_target: 'Model/GeoTarget',
  location_target: 'Model/LocationTarget',
  radius_target: 'Model/RadiusTarget',
  channel_appeal_info: 'Model/ChannelAppealInfo',
  ad_source: 'Model/AdSource',
  offline_ad_identity: 'Model/OfflineAdIdentity',
  carousel_ad: 'Model/CarouselAd',
  image_ad: 'Model/ImageAd',
  lead_image_ad: 'Model/LeadImageAd',
  provisioning_editorial_result: 'Model/ProvisioningEditorialResult',
  search_ad: 'Model/SearchAd',
  lead_ad: 'Model/LeadAd',
  video_ad: 'Model/VideoAd',
  extracted_address: 'Model/ExtractedAddress',
  location_target_recommendation: 'Model/LocationTargetRecommendation',
  radius_target_recommendation: 'Model/RadiusTargetRecommendation',
  entity_tag_header_value: 'Model/EntityTagHeaderValue',
  business_category_recommendations: 'BusinessCategoryRecommendations',
  prepare_ad_recommendation: 'PrepareAdRecommendation',
  post_a_b_testing_flight_log: 'PostABTestingFlightLog',
  post_a_b_testing_event_log: 'PostABTestingEventLog',
};

export const schema = new Schema(
  schemaToModelMapping,
  name => edm.schema.schemas[name]
);
